import DamagedPointsComponent from '@/common/components/adjusterReport/damagedPoints/DamagedPointsComponent';
import LocalDamagedPoints from '@/common/components/adjusterReport/damagedPoints/LocalDamagedPoints';
import Button from '@/common/components/base/button/Button';
import Typography from '@/common/components/base/typography/Typography';
import MainLayout from '@/common/components/layouts/MainLayout';
import { ADJUSTER_REPORT_DAMAGED_LINKS } from '@/modules/adjusterReportModules/adjusterReport/links/damaged/damagedLinks';
import useDamagedPoints from '@/modules/adjusterReportModules/IncidentParticipants/store/damagePoints/useDamagedPoints';
import { useNavigate, useParams } from 'react-router-dom';
import { Box } from 'styled-system/jsx';

export default () => {
  return (
    <MainLayout
      title="زیان‌دیده / تصاویر"
      header="titleHeader"
      hasBottomPadding
    >
      <DamagedPoints />
    </MainLayout>
  );
};

const DamagedPoints = () => {
  const { damagedPoints } = useDamagedPoints();
  const navigate = useNavigate();
  const { id, damagedId } = useParams();

  const addDamagedPoints = () => {
    navigate(
      ADJUSTER_REPORT_DAMAGED_LINKS.DAMAGED_IMAGES({
        damagedId: damagedId!,
        id: id!,
      }).ADJUSTER_VEHICLE.takePhotoGuide,
      { replace: true },
    );
  };

  return (
    <DamagedPointsComponent
      needSelectedPoints={false}
      userType="damaged"
      header={
        <Box mt={24}>
          <Typography color="black-1" textStyle="b2">
            کارشناس محترم، در صورت داشتن نقاط آسیب‌دیده نسبت به ثبت آن اقدام
            نمایید؛ در غیر این صورت می‌توانید این مرحله را رد کنید.
          </Typography>
        </Box>
      }
      pointsList={<LocalDamagedPoints />}
      buttons={
        <Box position="fixed" w={'90%'} maxW="maxContainer" bottom={10}>
          <Button
            disabled={damagedPoints?.length < 1}
            fullWidth
            onClick={addDamagedPoints}
            mt={40}
          >
            ثبت
          </Button>
        </Box>
      }
    />
  );
};
